import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CountdownClock } from './CountdownClock';
import { CtaButton } from './CtaButton';
import { product } from '../data/content';
const reassurances = ['Payment is one-time · No subscription', 'Instant access to all materials', '7-day satisfaction guarantee'];
export function FinalCta() {
  return <section className="w-full bg-espresso py-16 text-cream sm:py-20" aria-labelledby="final-cta-heading" data-id="element-91" data-mp="15fgj2o0dj92i">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-92" data-mp="1eebnpvnrsb3p">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-goldlight" data-id="element-93" data-mp="1eds48aih1enk">
          Final countdown
        </p>
        <h2 id="final-cta-heading" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl" data-id="element-94" data-mp="1o3v6707km2y1">
          Complete package, launch price
        </h2>
        <div className="mt-8" data-id="element-95" data-mp="1x4ta7ii0eagm">
          <CountdownClock tone="light" data-id="element-96" data-mp="1x5uorwy8hf33" />
        </div>

        <p className="mt-10 font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-cream/60" data-id="element-97" data-mp="n5m909ym4i5k">
          6 volumes + 5 bonuses
        </p>
        <div className="mt-3 flex items-end justify-center gap-4" data-id="element-98" data-mp="s5gxy7ytuxnz">
          <p className="font-display text-6xl font-semibold leading-none" data-id="element-99" data-mp="x38z7sld3w4u">
            {product.price}
          </p>
          <p className="font-display text-2xl font-semibold text-cream/50 line-through" data-id="element-100" data-mp="123wni6i7hyvd">
            {product.compareAt}
          </p>
        </div>
        <p className="mt-3 font-sans text-sm font-semibold text-goldlight" data-id="element-101" data-mp="162ma8pp4wsro">
          You save $680 today
        </p>

        <div className="mx-auto mt-8 max-w-lg" data-id="element-102" data-mp="1fujok5bfw0um">
          <CtaButton label="Yes, I want it now" size="large" tone="gold" data-id="element-103" data-mp="1fus301n7ne7x" />
        </div>

        <ul className="mt-7 flex flex-col items-center gap-2" data-id="element-104" data-mp="1ks1oj67hb5qh">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2 font-sans text-sm text-cream/70" data-id="element-105" data-mp="1pu0sah74s4ny">
              <CheckIcon className="h-4 w-4 text-goldlight" aria-hidden="true" data-id="element-106" data-mp="1trotu33bwvot" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}